import { forwardRef, createElement } from 'react';

function IconChatSolid(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.557 13.056c1.474.7 2.443 1.881 2.443 3.222 0 1.294-.903 2.44-2.292 3.147l.89 1.582a.556.556 0 01-.748.761l-.084-.055-2.059-1.647a7.87 7.87 0 01-1.263.1c-2.853 0-5.205-1.506-5.52-3.444 2.666-.007 5.071-.766 6.817-1.966a7.924 7.924 0 001.802-1.682l.014-.018zM10.889 3.5c4.91 0 8.889 2.736 8.889 6.111 0 3.309-3.825 6.004-8.601 6.108l-.426.003-5.406 4.324a.556.556 0 01-.832-.706l2.398-4.262C3.999 14.074 2 12.003 2 9.61 2 6.236 5.98 3.5 10.889 3.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ChatSolid = /*#__PURE__*/forwardRef(IconChatSolid);

export default ChatSolid;
//# sourceMappingURL=ChatSolid.js.map
